import React from "react";
import PropTypes from 'prop-types';
import "./lineSkeleton.scss";
function URLineSkeleton(props: any) {
  let {className } = props;
  return (
    <>
      <div className={className}></div>
    </>

  );
}

export {
  URLineSkeleton
};

URLineSkeleton.propTypes = {
  className: PropTypes.any,
  profileInfo: PropTypes.any
};